import styled from 'styled-components';

export const StyledToggler = styled.div`
  border-radius: 500px;
`;
